// extracted by mini-css-extract-plugin
export default {"input":"Limit_input__ZLm75","submitBtn":"Limit_submitBtn__QB3hi","pumpInfoSection":"Limit_pumpInfoSection__e+v61","pumpInput":"Limit_pumpInput__uI7Mg","isRed":"Limit_isRed__HTU4r"};